import React from 'react';
import Link from 'gatsby-link';

const iteration = ({node}, idx) => {
	if(idx < 3){
		let image = '';
		if (node.avatar) {
			image = node.avatar;
		} else {
			image = node.image;
		}
		return (
			<li className="small-12 medium-4" key={idx}>
				<div className="content">
					<Link to={`${node.langPath}`} title="">
						<img src={`/${image}`} alt="" />
					</Link>
					<p>‘{node.title}’</p>
				</div>
			</li>
		)
	}
};

const ProductList = ({info, data, dataTranslated, section, categories}) => {
	return (
		<section className="product-list bg-gray">
			<div className="container">
				<div className="row">
					<div className="small-12">
						<h2>{info.title}</h2>
					</div>
				</div>
				<ul className="row">
					{data.map(iteration)}
				</ul>
				<div className="row">
					<div className="small-12">
						<div className="btn-container">
							<Link className="btn" to={`${section.langPath}${section.link}`}>{dataTranslated[0].node.gustazos}</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/product-list/index.jsx